import { keycloak } from './keycloak';
import { KeycloakUserClaims, mapKeycloakUser } from './auth-utils';

export { mapKeycloakUser, syncTokenToStorage } from './auth-utils';
export type { KeycloakUserClaims } from './auth-utils';

/**
 * Resolves user display data from id/access token claims, then Keycloak userinfo API.
 */
export async function resolveKeycloakUser(): Promise<{
	email: string;
	fullName: string;
} | null> {
	const claims = (keycloak.idTokenParsed ?? keycloak.tokenParsed) as
		| KeycloakUserClaims
		| undefined;

	let user = mapKeycloakUser(claims);
	if (user) {
		return user;
	}

	try {
		const profile = await keycloak.loadUserProfile();
		user = mapKeycloakUser({
			email: profile.email,
			given_name: profile.firstName,
			family_name: profile.lastName,
			preferred_username: profile.username,
		});
		if (user) {
			return user;
		}
	} catch (error) {
		console.warn('No se pudo cargar el perfil de Keycloak', error);
	}

	const subject = keycloak.subject ?? keycloak.tokenParsed?.sub;
	if (subject) {
		return {
			email: subject,
			fullName: subject,
		};
	}

	return null;
}
